module.exports = __webpack_public_path__ + "img/Zsuzsi_Simon_Alexandru_03.a7c92091.jpg";